module.exports = __webpack_public_path__ + "img/team_leader_1.7cf5a313.png";